import type { SVGProps } from 'react';
const SvgSupportSidebar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g fill="currentColor" fillOpacity={0.88} clipPath="url(#support-sidebar_svg__a)">
      <path d="M8 0a8 8 0 1 0 .001 16.001A8 8 0 0 0 8 0m0 14.643A6.644 6.644 0 0 1 8 1.357a6.644 6.644 0 0 1 0 13.286" />
      <path d="M9.993 4.512A3 3 0 0 0 8 3.785a3.02 3.02 0 0 0-1.993.727c-.557.487-.864 1.143-.864 1.845v.135c0 .079.064.143.142.143h.858a.143.143 0 0 0 .142-.143v-.135c0-.788.77-1.429 1.715-1.429.944 0 1.714.641 1.714 1.429 0 .555-.393 1.064-1.002 1.298a2 2 0 0 0-1.285 1.89v.383c0 .079.064.143.142.143h.858a.143.143 0 0 0 .142-.143v-.405a.86.86 0 0 1 .552-.8c1.054-.406 1.734-1.334 1.734-2.366.002-.702-.305-1.358-.862-1.845m-2.708 7.416a.714.714 0 1 0 1.429 0 .714.714 0 0 0-1.429 0" />
    </g>
    <defs>
      <clipPath id="support-sidebar_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSupportSidebar;
